import React, { useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card } from 'primereact/card';
import { StatusMasterForm } from "../usermaintenance/statusmaster/StatusMaster";
import { ManuMasterForm } from "../usermaintenance/menumaster/MenuMaster";
import { ChannelMasterForm } from "../usermaintenance/channelmaster/ChannelMaster";
import { UserMasterForm } from "../usermaintenance/usermaster/UserMaster";

import { Button } from 'primereact/button';
        

export const SuperAdminView = () => {
  const [setShowChannel, setShoeChannel] = useState(false);
  const [setShowMenu, setShoeMenu] = useState(false);
  const [setShowStatus, setShoeStatus] = useState(false);
  const [showUserMaster, setshowUserMaster] = useState(false);

  const showChannel = () => {
    setShoeChannel(true);
    setShoeMenu(false);
    setShoeStatus(false);
    setshowUserMaster(false);
  };
  const showmenu = () => {
    setShoeChannel(false);
    setShoeMenu(true);
    setShoeStatus(false);
    setshowUserMaster(false);
  };
  const showStatus = () => {
    setShoeChannel(false);
    setShoeMenu(false);
    setShoeStatus(true);
    setshowUserMaster(false);
  };
  const showUser = () => {
    setShoeChannel(false);
    setShoeMenu(false);
    setShoeStatus(false);
    setshowUserMaster(true);
  };
  return (
    <div>
      <h2>Super Admin List</h2>
      <div style={{ position: "absolute" }}>
        <Card>
          <div >
            <div style={{ marginBottom: "10px" }}><Button label="Channel  Master" outlined onClick={showChannel} /></div>
            <div style={{ marginBottom: "10px" }}><Button label="Menu Master" outlined onClick={showmenu} /></div>
            <div style={{ marginBottom: "10px" }}><Button label="Status Master" outlined onClick={showStatus} /></div>
            <div style={{ marginBottom: "10px" }}><Button label="User Master" outlined onClick={showUser} /></div>
          </div>
        </Card>
      </div>
      <div style={{ marginLeft: "200px" }}>
        <Card>
          {setShowChannel &&
            <ChannelMasterForm />
          }
          {setShowMenu &&
            <ManuMasterForm />
          }
          {setShowStatus &&
          <StatusMasterForm />
          }
          { showUserMaster &&
          <UserMasterForm/>
          }
        </Card>
      </div>
      {/* </Card> */}
    </div>
  );
}
